import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center font-mono text-[11px] uppercase tracking-[0.25em] text-[#4B5563]"
      >
        Checking session…
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  if (adminOnly && user.role !== "admin") {
    return (
      <div
        data-testid="forbidden-screen"
        className="min-h-screen flex flex-col items-center justify-center gap-4 px-6"
      >
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FF3333]">
          403 · admin only
        </div>
        <div className="font-display font-black text-3xl tracking-tighter">
          This area is restricted to administrators.
        </div>
        <a href="/admin" className="border border-[#0A0A0A] px-4 py-2 text-sm hover:bg-[#0A0A0A] hover:text-white">
          Back to dashboard
        </a>
      </div>
    );
  }

  return children;
}
